import * as actions from './actions'
import * as getters from './getters'
import * as types from '../mutation-types'

const state = {
  companies: {},
  company: {},
  similar: {},
  categories: [],
  vacancies: {}
}

const mutations = {
  [types.COMPANIES] (state, data) {
    state.companies = data
  },
  [types.COMPANY_ENTRY] (state, data) {
    state.company = data
  },
  [types.COMPANY_VACANCIES] (state, data) {
    if (data.loadMore === true) {
      state.vacancies.current = data.current
      state.vacancies.before = data.before
      state.vacancies.next = data.next
      data.items.forEach(item => {
        state.vacancies.items.push(item)
      })
    } else {
      state.vacancies = data
    }
  },
  [types.SIMILAR_COMPANIES] (state, data) {
    state.similar = data
  }
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}



// WEBPACK FOOTER //
// ./src/vuex/companies/store.js